import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step356581Meta extends BaseModel {
  /**
   * @var {?boolean}
   */
  hasProbateRefereeFee;

  /**
   * @var {?number}
   */
  probateRefereeFeeAmount;

  constructor(model = {}) {
    super();

    this.hasProbateRefereeFee = model.hasProbateRefereeFee;
    this.probateRefereeFeeAmount = model.probateRefereeFeeAmount
      ? parseFloat(model.probateRefereeFeeAmount)
      : null;
  }
}
